/* eslint-disable no-console */
'use client'

import { Button } from '@populix/pop-ui'
import { usePathname } from 'next/navigation'
import { ReactNode } from 'react'
import { MdOutlineWarningAmber } from 'react-icons/md'

export default function ErrorUi({
  reset,
  children,
  error,
}: {
  readonly error?: Error & { digest?: string; errorMessage?: string; errorCode?: string }
  readonly reset?: { label?: string; action?: () => void }
  readonly children?: ReactNode
}) {
  const pathname = usePathname()

  return (
    <div
      className={`flex flex-col items-center justify-center p-4 ${
        pathname === '/home' ? 'h-screen w-screen' : 'h-full min-h-96 w-full'
      }`}
    >
      <div className='flex flex-col items-center justify-center gap-5'>
        <MdOutlineWarningAmber className='h-16 w-16 text-pop-yellow-200' />
        <h2 className='text-lg font-semibold text-slate-900'>
          Sorry, we are experiencing an issue
        </h2>
        <div className='flex flex-col'>
          {(error?.errorCode || error?.name) && (
            <span className='text-center text-xs text-neutral-900'>
              Code: {error?.errorCode || error?.name}
            </span>
          )}
          {(error?.message || error?.errorMessage) && (
            <span className='text-center text-xs text-neutral-900'>
              {error?.message || error?.errorMessage}
            </span>
          )}
        </div>
        {children}
        <div className='flex w-full !max-w-md gap-4'>
          {pathname !== '/home' && pathname !== '/auth/partner/gopay' && (
            <Button
              variant='contained'
              onClick={() => {
                reset?.action ? reset.action() : window.location.replace('/home')
              }}
              color='primary'
            >
              {reset?.label ? reset.label : 'Back to Survey List'}
            </Button>
          )}
          <Button variant='text' onClick={() => window.location.reload()} color='primary'>
            Reload
          </Button>
        </div>
      </div>
    </div>
  )
}
